import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const download: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M9.844-1.14A.5.5 0 0 0 10-1.5a.46.46 0 0 0-.156-.344A.46.46 0 0 0 9.5-2a.5.5 0 0 0-.36.156A.47.47 0 0 0 9-1.5q0 .206.14.36.154.14.36.14.201 0 .344-.14m2 0A.5.5 0 0 0 12-1.5a.46.46 0 0 0-.156-.344A.46.46 0 0 0 11.5-2a.5.5 0 0 0-.36.156.47.47 0 0 0-.14.344q0 .206.14.36.154.14.36.14.201 0 .344-.14M13-3.25v2.5q0 .316-.219.531A.72.72 0 0 1 12.25 0H.75a.7.7 0 0 1-.531-.219A.7.7 0 0 1 0-.75v-2.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-4h3.64l1.048 1.063Q5.89-2.5 6.5-2.5a1.48 1.48 0 0 0 1.063-.437L8.625-4h3.625q.31 0 .531.219A.74.74 0 0 1 13-3.25m-2.531-4.453q.124.329-.11.547l-3.5 3.5A.46.46 0 0 1 6.5-3.5a.44.44 0 0 1-.344-.156l-3.5-3.5q-.25-.218-.11-.547A.455.455 0 0 1 3-8h2v-3.5q0-.201.14-.344A.5.5 0 0 1 5.5-12h2c.133 0 .25.055.344.156.101.094.156.211.156.344V-8h2c.219 0 .375.102.469.297m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "12",
    width: "13",
  }
};

export const upload: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M9.844-.14A.5.5 0 0 0 10-.5a.46.46 0 0 0-.156-.344A.46.46 0 0 0 9.5-1a.5.5 0 0 0-.36.156A.47.47 0 0 0 9-.5q0 .206.14.36.154.14.36.14.201 0 .344-.14m2 0A.5.5 0 0 0 12-.5a.46.46 0 0 0-.156-.344A.46.46 0 0 0 11.5-1a.5.5 0 0 0-.36.156A.47.47 0 0 0 11-.5q0 .206.14.36.154.14.36.14.201 0 .344-.14M13-2.25v2.5a.74.74 0 0 1-.219.531.74.74 0 0 1-.531.219H.75A.72.72 0 0 1 .219.781.72.72 0 0 1 0 .25v-2.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-3h3.344q.153.438.547.719c.257.187.547.281.859.281h2c.32 0 .61-.094.86-.281q.386-.28.562-.719h3.328q.31 0 .531.219A.74.74 0 0 1 13-2.25m-2.531-5.062q-.14.314-.469.312H8v3.5a.5.5 0 0 1-.156.36A.47.47 0 0 1 7.5-3h-2a.52.52 0 0 1-.36-.14A.52.52 0 0 1 5-3.5V-7H3a.45.45 0 0 1-.453-.312.44.44 0 0 1 .11-.547l3.5-3.5A.47.47 0 0 1 6.5-11.5q.218 0 .36.14l3.5 3.5q.232.236.109.548m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11.5)"
    />
  ),
  svgProps: {
    height: "12.5",
    width: "13",
  }
};
